module.exports = __webpack_public_path__ + "static/media/logNav_black.8e6e2e35.svg";